import React, { useState } from "react";
import TogglerBody from "../../TogglerBody";
import { RxCross1 } from "react-icons/rx";
import SquareIcon from "../../SquareIcon/SquareIcon";
import "./notificationTamplateBlock.scss";

const NotificationTamplateBlockPlug = ({ setIsPopUpSubscribe }) => {
  const [isOnWhiteList, setIsOnWhiteList] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValueUser, setInputValueUser] = useState("");
  const [actionArr, setActionArr] = useState([
    {
      img: "Ban.svg",
      className: "ban",
      name: "Ban",
    },
    {
      img: "Kick.svg",
      className: "kick",
      name: "Kick",
    },
    {
      img: "RevokeRoles.svg",
      className: "revoke_roles",
      name: "Revoke Roles",
    },
    {
      img: "Log.svg",
      className: "log",
      name: "Log",
    },
  ]);
  const [userList, setUserList] = useState([
    "Repeated Text",
    "Z̴̞͝a̵̞̐l̴̘̏g̵̘̈́o̴̻͆  Text",
    "External Links",
    "Server Invites",
    "Images",
    "Files",
  ]);
  const [arrAdmin, setArrAdmin] = useState([
    {
      color: "C44A4A",
      img: "crown",
      name: "www.github.com",
    },
    {
      color: "D8833B",
      img: "bot",
      name: "www.slack.com",
    },
    {
      color: "5296D5",
      img: "manager",
      name: "www.google.com",
    },
  ]);
  const [arrUsers, setArrUsers] = useState([
    {
      color: "",
      img: "meow",
      name: "# 💬｜chat-room",
    },
    {
      color: "",
      img: "hecker",
      name: "# 🌠｜memes",
    },
    {
      color: "",
      img: "koi",
      name: "# 🚧｜disclaimer",
    },
  ]);

  const addNewRoleAmdin = () => {
    const newRole = {
      name: inputValue,
      color: "",
      img: "",
    };
    setArrAdmin((prev) => [...prev, newRole]);
    setInputValue("");
  };

  const handleKeyPressAdmin = (e) => {
    if (inputValue && e.key === "Enter") {
      addNewRoleAmdin();
    }
  };

  const deleteAdmin = (index) => {
    // Приклад видалення для arrAdmin
    setArrAdmin((prev) => prev.filter((_, idx) => idx !== index));
  };

  const addNewRoleUser = () => {
    const newRole = {
      name: inputValueUser,
      color: "",
      img: "",
    };
    setArrUsers((prev) => [...prev, newRole]);
    setInputValueUser("");
  };

  const handleKeyPressUser = (e) => {
    if (inputValueUser && e.key === "Enter") {
      addNewRoleUser();
    }
  };

  const deleteUser = (index) => {
    // Приклад видалення для arrAdmin onClick={() => setIsPopUoSubscribe(true)}
    setArrUsers((prev) => prev.filter((_, idx) => idx !== index));
  };
  return (
    <div
      className="notification_tamplate_block_wrap"
      onClick={() => setIsPopUpSubscribe(true)}
      style={{ maxHeight: "500px" }}
    >
      <div className="notification_tamplate_block_wrap_bg"></div>
      <SquareIcon
        squareFirstClassname={"first_square_bg_pink"}
        squareSecondClassname={"second_square_bg_pink"}
        imgSrc={"/img/NotificationsIcon.svg"}
      />
      {/* <img  className='notification_tamplate_block_wrap_img' src="/img/Notifications.svg" alt="" /> */}
      <h3>
        Notifications <label htmlFor="">PRO</label>
      </h3>
      <div
        className="notification_tamplate_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="notification_tamplate_block_item_toggler">
          <TogglerBody isOn={isOnWhiteList} setIsOn={setIsOnWhiteList} />
          <p>Send Advanced Alerts</p>
        </div>
      </div>

      <div className="status_block_item notification_tamplate_block_blur">
        <p className="status_block_item_title_solo">Whitelist Roles:</p>
        <div className="white_list_block_item_arr_user_wrap">
          {arrUsers.map((item, idx) => (
            <div
              key={idx}
              className="access_component_user_one white_list_block_user_one"
            >
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteUser(idx)}
              >
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputValueUser}
            onChange={(e) => {
              setInputValueUser(e.target.value);
            }}
            onKeyPress={handleKeyPressUser}
          />
        </div>
      </div>
      <div className="status_block_item notification_tamplate_block_blur">
        <p className="status_block_item_title_solo">Whitelist Roles:</p>
        <div className="white_list_block_item_arr_user_wrap">
          {arrUsers.map((item, idx) => (
            <div
              key={idx}
              className="access_component_user_one white_list_block_user_one"
            >
              {/* { item?.img &&
                                    <img src={`/img/user/${item?.img}.svg`} alt="" />
                                } */}
              {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteUser(idx)}
              >
                <RxCross1 />
              </span>
            </div>
          ))}
          <input
            type="text"
            placeholder="..."
            value={inputValueUser}
            onChange={(e) => {
              setInputValueUser(e.target.value);
            }}
            onKeyPress={handleKeyPressUser}
          />
        </div>
      </div>
      <div className="notification_tamplate_block_item_img_plug_wrap">
        <div className="notification_tamplate_block_item_img_plug">
          <img src="/img/plugSubcribe.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default NotificationTamplateBlockPlug;
